import { LinkAction } from '@sharedComponents/LinkAction';
import { Favorites } from '@app/Layout/Header/Blocks';
import { BuyerSelection } from './BuyerSelection';
import { Grid } from '@ui-kit/Grid';
import { ButtonProfileHeader } from '@entities/Auth';

import styles from './SubMenu.module.scss';

export const SubMenu = () => {
  return (
    <div className={styles.Wrapper}>
      <Grid row gap={'30px'} at>
        <LinkAction data-testid="header-btn-actions" />
        <BuyerSelection />
        <Favorites />
        <ButtonProfileHeader />
      </Grid>
    </div>
  );
};
